import React, { Component } from 'react'
import MyPATLink from '../../common/MyPATLink'
import ReCAPTCHA from 'react-google-recaptcha';
import './LoginV2.css'
import {
  WithStyles,
  createStyles,
  Grid,
} from "@material-ui/core";
import {withRouter} from 'react-router'
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import { LoginCaptcha, LoginRequestV2, SiteKey, UserEmail, UserEmpCode, UserErrorV2, UserMobile } from '../types/LoginRequestV2';
import { MyPATToaster } from '../../common';
import CancelIcon from '@material-ui/icons/Cancel';
import config from '../../../config/config';
import { singleUserAxios } from '../../../services/axios';
import { connect } from 'react-redux';
import userActionsV2 from '../actions/userActionsV2';

const styles = (theme: Theme) =>
  createStyles({
    mainTitle: {
      fontSize: "24px",
      fontWeight: 400,
      lineHeight: "30px",
      marginBottom: "20px",
      marginTop: "30px",
    },
    subTitle: {
      fontSize: "16px",
      fontWeight: 600,
      display: 'block',
      lineHeight: "20px",
    },
    loginPwd: {
      display: 'flex',
      flexDirection: 'column',
      marginBottom: "30px",
      position: 'relative',
    },
    dropdownMenu: {
      minHeight: "50px",
      maxHeight: "200px",
      "overflow-y": "auto",
    },
  });

  export interface MyProps extends WithStyles<typeof styles>{
    loginSuccess: Function,
    loginData: any,
    showErrorToast: any,
    history: any,
    location: any,
    userData: any,
    clearErrorMsg: Function,
  }

  export interface LoginFormState {
    form: LoginRequestV2,
    password: string,
    isHidden: boolean,
    isPasswordSet: string,
    isPasswordSetTost: boolean,
    reCaptcha: LoginCaptcha,
    siteKey: SiteKey,
    captchaError:boolean,
    captchaShow: boolean,
    captchaChecked: boolean,
    errorMsg: boolean,
    withEmail: UserEmail,
    withMobile: UserMobile,
    withEmpCode: UserEmpCode,
    captchaErrorSignInOTP: boolean,
    captchaShowSignInOTP: boolean,
    captchaCheckedSignInOTP: boolean,
}

class LoginWithPassword extends Component<MyProps, LoginFormState> {
  currentProps: MyProps;
  constructor(props: MyProps, state: any) {
    super(props)
    this.currentProps = props;
    this.state = {
      form: {
        osType: 'web',
        device: 'desktop',
        appName: 'authors',
        password: '',
      },
      withEmail: {
        appName: 'authors',
        email: '',
        captchaToken: '',
      },
      withMobile: {
        appName: 'authors',
        mobile: '',
        captchaToken: '',
        countryCode: '',
      },
      withEmpCode: {
        appName: 'authors',
        empCode: '',
        captchaToken: '',
      },
      reCaptcha: {
        loginCaptcha: ''
      },
      siteKey: {
        siteKey: config.captchaKey
      },
      password: '',
      isHidden: true,
      isPasswordSet: 'false',
      isPasswordSetTost: false,
      captchaError: false,
      captchaShow: false,
      captchaChecked: false,
      errorMsg: false,
      captchaErrorSignInOTP: false,
      captchaShowSignInOTP: false,
      captchaCheckedSignInOTP: false,
    }

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmitWithOTP = this.handleSubmitWithOTP.bind(this);
    this.showHide = this.showHide.bind(this);
    this.warningMsg = this.warningMsg.bind(this)
    this.goToForgotPass = this.goToForgotPass.bind(this)
    this.setState({isPasswordSet: 'false', isPasswordSetTost: false});
    this.reCaptcha('');
    this.reCaptchaSignInOTP('');
    this.setState({ siteKey: this.state.siteKey.siteKey, captchaError: false, captchaShow: false });
    this.setState({ captchaErrorSignInOTP: false, captchaShowSignInOTP: false });
    this.tostMsgClose = this.tostMsgClose.bind(this);
    this.captchaGenerate();
    if (((this.currentProps || {}).location || {}).data === undefined) {
      window.location.href = '/login';
    }
  }

  handleChange(e: any) {
    const { name, value } = e.target;
    this.setState({
      password: e.target.value, errorMsg: false
    });
  }

  captchaGenerate() {
    let captchaShow = false;
    if (!this.state.captchaChecked) {
      singleUserAxios.get(`v4/show-captcha`).then((res: any) => {
        if (res.data.showCaptcha) {
          captchaShow = true;
        }
      });
    }
  }

  captchaGenerateSignInOTP() {
    if (!this.state.captchaCheckedSignInOTP) {
      singleUserAxios.get(`v4/show-captcha`).then((res: any) => {
        if (res.data.showCaptcha) {
          this.setState({ captchaShowSignInOTP: true, captchaErrorSignInOTP: true })
        }
      });
    }
  }

  componentDidUpdate() {
    if (this.state.captchaChecked === true) {
      setTimeout(() => {
        this.captchaGenerate();
      }, 30000)
    }
  }

  handleSubmit(e: any) {
    localStorage.removeItem('backToForgot');
    e.preventDefault();
    if (this.state.password === '') {
      this.setState({errorMsg: true});
    } else {
      this.setState({errorMsg: false});
    }
    let currentState: any = {
      osType: 'web',
      device: 'desktop',
      appName: 'authors',
      password: this.state.password,
    }
    if(this.currentProps.loginData.data.type === 'empCode') {
      currentState.empCode = this.currentProps.loginData.data.username
    } else if (this.currentProps.loginData.data.type === 'mobile') {
      currentState.mobile = this.currentProps.loginData.data.username
    } else {
      currentState.email = this.currentProps.loginData.data.username
    }
    this.props.loginSuccess(currentState);
  }

  showHide() {
    this.setState({ isHidden: !this.state.isHidden })
  }

  warningMsg() {
    this.setState({isPasswordSetTost: true})
    setTimeout(() => {
      this.setState({isPasswordSetTost: false})
    }, 5000)
  }

  reCaptcha = (value: any) => {
    this.setState({reCaptcha: value, captchaChecked: true, captchaError: false}, () => {

      if (value !== ''){
        this.goToForgotPass('', true);
      }
    });
  }

  reCaptchaSignInOTP = (value: any) => {
    this.setState({ reCaptcha: value, captchaCheckedSignInOTP: true, captchaErrorSignInOTP: false }, () => {
      if (value !== '') {
        this.handleSubmitWithOTP(true);
      }
    });
  }

  goToForgotPass(e?: any, fromCaptcha?: any) {
    // e.preventDefault();
    if (!fromCaptcha){
      this.captchaGenerate();
    }
    this.setState({captchaChecked: false});
      if (!this.state.captchaChecked) {
        this.setState({captchaShow: true, captchaError: true});
      } else {
        this.setState({captchaChecked: false});
        let currentState: any = {
          appName: 'authors',
          captchaToken: this.state.reCaptcha,
        }
        if(this.currentProps.loginData.data.type === 'empCode') {
          currentState.empCode = this.currentProps.loginData.data.username
        } else if (this.currentProps.loginData.data.type === 'mobile') {
          currentState.mobile = this.currentProps.loginData.data.username
          currentState.countryCode = this.currentProps.loginData.data.countryCode
        } else {
          currentState.email = this.currentProps.loginData.data.username
        }
        if (!this.state.reCaptcha) {
          this.setState({captchaError: true});
          return
        }
        singleUserAxios.post('v4/forgot-password-otp', currentState).then((res: any) => {
          this.props.history.push({pathname: "/forgot-with-otp", data: {
            username: this.currentProps.loginData.data.username,
            type: this.currentProps.loginData.data.type,
            forgotData: res.data,
            captchaToken: this.state.reCaptcha,
            countryCode: this.currentProps.loginData.data.countryCode, 
            countryFlag: this.currentProps.loginData.data.countryFlag,
            loginVia: 'forgot',
            isPasswordSet: this.currentProps.loginData.data.isPasswordSet === 'false' ? 'false' : 'true',
          }});
        });
      }
  }

  tostMsgClose() {
    this.setState({isPasswordSetTost: false})
  }

  backToLogin = () => {
    this.props.clearErrorMsg();
  }

  handleSubmitWithOTP(fromCaptcha?: any) {
    localStorage.removeItem(config.localStorageKey);
    localStorage.removeItem('backToForgot');
    localStorage.removeItem('tempAuthToken');
    if (!fromCaptcha) {
      this.captchaGenerateSignInOTP();
    }
    const regex = /^[A-Za-z0-9_!#$%&'*+\/=?`{|}~^.-]+@[A-Za-z0-9.-]+$/;
    const userName = this.props.loginData.data.username;
    const countryCode = this.props.loginData.data.countryCode;
    const usernameType = this.props.loginData.data.type;
    const reCaptcha = this.state.reCaptcha;

    if (userName) {
      let payload = '';
      payload += '?id=' + userName,
        payload += '&appName=' + 'authors'

      // SignIn Via Email
      let withEmail: UserEmail = {
        appName: 'authors',
        email: userName
      }
      if (typeof reCaptcha === 'string') {
        withEmail['captchaToken'] = reCaptcha;
      }
      this.setState({ withEmail });

      // SignIn Via Mobile
      let withMobile: UserMobile = {
        appName: 'authors',
        mobile: userName,
        countryCode: countryCode
      }
      if (typeof reCaptcha === 'string') {
        withMobile['captchaToken'] = reCaptcha;
      }
      this.setState({ withMobile });

      // SignIn Via Mobile
      let withEmpCode: UserEmpCode = {
        appName: 'authors',
        empCode: userName
      }
      if (typeof reCaptcha === 'string') {
        withEmpCode['captchaToken'] = reCaptcha;
      }
      this.setState({ withEmpCode });
      singleUserAxios.get(`v4/verify-user` + payload).then((res: any) => {
        if (res.data.isValidUser) {
          let data: any = {
            username: userName,
            type: usernameType,
            loginVia: 'otp',
            isPasswordSet: !res.data.isPasswordSet ? 'false' : 'true',
            countryCode: countryCode,
            countryFlag: this.props.loginData.data.countryFlag,
          }

          if (typeof reCaptcha === 'string') {
            data['captchaToken'] = reCaptcha;
          }

          localStorage.setItem('isFirstUser', !res.data.isPasswordSet ? 'true' : 'false')
          if (this.state.captchaShowSignInOTP && !this.state.captchaCheckedSignInOTP) {
            this.setState({ captchaShowSignInOTP: true, captchaErrorSignInOTP: true })
          } else {
            if (reCaptcha === null) {
              this.setState({ captchaCheckedSignInOTP: false })
              this.captchaGenerateSignInOTP();
            } else {
              if (new RegExp(regex).test(userName)) {
                if (usernameType === 'email') {
                  singleUserAxios.post(`v4/login/send-otp`, withEmail).then((res: any) => {
                    this.props.history.push({ pathname: "/login-with-otp", data: { ...data, userDataPass: res.data } });
                  })
                }
              } else if (usernameType === 'empCode' && userName.length === 5) {
                singleUserAxios.post(`v4/login/send-otp`, withEmpCode).then((res: any) => {
                  this.props.history.push({ pathname: "/login-with-otp", data: { ...data, userDataPass: res.data } });
                })
              } else if (usernameType === 'mobile' && userName.length > 5 && userName.length === 10) {
                singleUserAxios.post(`v4/login/send-otp`, withMobile).then((res: any) => {
                  this.props.history.push({ pathname: "/login-with-otp", data: { ...data, userDataPass: res.data } });
                });
              }
            }
          }
        }
      });
    }
  }

  render() {
    const { siteKey, errorMsg } = this.state
    let maskedUser = this.currentProps.loginData.data.username;
    const logindataType = this.currentProps.loginData.data.type;
    const loginUserName = this.currentProps.loginData.data.username;
    const loginTypeEmpCode = logindataType === 'empCode';

    //logic for masking
    if (logindataType === 'email'){
      maskedUser = loginUserName.replace(
        /^(..)(.*)(@.*)$/,
        (_: any, a: any, b: string, c: any) => a + b.replace(/./g, '*') + c,
      );
    } else {
      let arr = loginUserName.split('');
      const maskIndex = loginTypeEmpCode ? 1 : 2;
      for (let i = maskIndex; i < loginUserName.length - maskIndex; i++) {
        arr[i] = '*';
      }
      maskedUser = arr.join('');
    }

    return (
      <>
        
        <div className="login-container">
          <em></em><em></em><em></em><em></em>
          <div className="sign-in-container">
          <MyPATLink align="right" variant="body2" to={{pathname: '/login',state: { data: {username: this.currentProps.loginData.data.username, type: this.currentProps.loginData.data.type, countryCode: this.currentProps.loginData.data.countryCode, countryFlag: this.currentProps.loginData.data.countryFlag}}}}>
          <div className="back-arrow" onClick={this.backToLogin}>
            <svg width="24" height="25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M0 12l12 12.002 2.12-2.123L5.742 13.5H24v-3H5.742l8.378-8.379L12 0 0 12z" fill="#333" />
            </svg>
          </div>
          </MyPATLink>
            <img src="/assets/svg/authors-new-logo.svg" className="logoCms" alt="mypat logo" />
            <div className="signin-form">
            <h3 className='alignCenter'>Enter Password</h3>
              <div className="editMobEmailEmp">
                <i>{(((this.currentProps || {}).loginData || {}).data || {}).type === 'mobile' ? this.currentProps.loginData.data.countryCode+' - ' : null}{loginUserName} </i>
                <MyPATLink align="right" variant="body2" to={{pathname: '/login',state: { data: {username: this.currentProps.loginData.data.username, type: this.currentProps.loginData.data.type, countryCode: this.currentProps.loginData.data.countryCode, countryFlag: this.currentProps.loginData.data.countryFlag}}}}>
                <img src="/assets/img/singleSignin/editIcon.svg" onClick={this.backToLogin}/>
                </MyPATLink>
              </div>
              <form onSubmit={this.handleSubmit}>
              <div className="input-group">
                <div className="visible-password">
                  <input placeholder="Password" ref={(element: any) => element && element.focus()} className={errorMsg ? 'errorBorder' : ''} type={this.state.isHidden ? "password" : "text"} name="password" onChange={this.handleChange}/>
                  <span onClick={this.showHide} className="eye-icon">
                  <img src={this.state.isHidden ? '/assets/img/singleSignin/togglePasswordHide.svg' : '/assets/img/singleSignin/togglePassword.svg' } alt="show password" />
                  </span>
                </div>
                {errorMsg ? <div className="error">Please enter Password</div> : null}
                {this.props.userData.showErrorMsg ? <div className="error">Incorrect Password</div> : null}
              </div>
              <div className="forgotPwdCta"> 
                <a onClick={this.currentProps.loginData.data.isPasswordSet === 'false' ? this.warningMsg : this.goToForgotPass} href="javascript:void(0);">Forgot Password?</a>
              </div>
              <div className="captcha-container1">
                {this.state.captchaShow ?
                    <div className="captcha">
                      <ReCAPTCHA
                        sitekey={siteKey.siteKey}
                        onChange={this.reCaptcha}
                      />
                    </div> : null
                  }
                  {this.state.captchaError ?
                    <div className="error">
                      <span>Please select captcha</span>
                    </div> : null
                  }
              </div>
              <div className="input-group">
                <button type="submit" className="btn btn-primary submit-btn">
                  Sign In
                </button>
              </div>
              </form>
              <div className="orOption">
                <span></span>
              </div>
              <div className="inputGroup gapTwoBtn">
                <button type="submit" className=" text-btn" onClick={()=>{this.handleSubmitWithOTP(false)}}>
                  Sign in via OTP
                </button>
              </div>
              {this.state.captchaShowSignInOTP ?
              <div className="captcha-container">                
                  <div className="captcha">
                    <ReCAPTCHA
                      sitekey={siteKey.siteKey}
                      onChange={this.reCaptchaSignInOTP}
                    />
                  </div>
                {this.state.captchaErrorSignInOTP ?
                  <div className="error">
                    <span>Please select captcha</span>
                  </div> : null}
              </div> : null}
            </div>

            {this.state.isPasswordSetTost ? 
            <div className="toster warningmsg alert customNew" role="alert" id="warning-alert">
              <div className="toster-inner">
                {/* <div className="icon">
              <img src="/assets/images/warning.svg">
            </div> */}
                <div className="toster-content">
                  <b>You seem to be new here!</b>
                  <span>Please enter the default Password provided. For any assistance, contact your Glorifire Account Manager.</span>
                </div>
                <div className="close" onClick={this.tostMsgClose}>
                  <a href="javascript:void(0)">&times;</a>
                </div>
              </div>
            </div> : null
            }
          </div>
          <div className="sign-in-footer">
            <div className="footer-left">
              <p>&copy; Copyright 2024-2025 Edfora. All Rights Reserved</p>
            </div>
            <div className="footer-right">
              <a href="/terms-of-use"> Terms of Use </a> 
              <span>|</span> 
              <a href="/privacy-policy">Privacy Policy</a>
              <span>|</span>
              <a href="/disclaimer">Disclaimer</a>
              <span>|</span>
              <a href="/copyright">Copyright</a>
            </div>
          </div>
        </div>
        {/* {( this.props.showErrorToast &&
          <Grid>
          <MyPATToaster 
           icon={<CancelIcon />}
           heading="Error"
           toasterAlignment="bottomRight"
           toasterType="error"
           subPara="Your license has been expired, please contact your supervisor for license renewal."
          />
          </Grid>
        )} */}
      </>

    )
  }
}


const mapStateToProps = (state: any) => ({
  userData: state.loginData.userData
});

const mapDispatchToProps = {
  clearErrorMsg: userActionsV2.removeError
};
//@ts-ignore
export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withRouter(LoginWithPassword));
